import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  loading: false,
  customerDetailsData: {},
  error: "",
  success: false,
  status: "",
};

const fetchCustomerDetails = createAsyncThunk(
  "customer/fetchCustomer",
  async () => {
    try {
      const result = await axios.get(
        "https://apac.api.capillarytech.com/mobile/v2/api/customer/get?format=json&gap_to_upgrade_for=0&gap_to_renew=0&mlp=true&user_group=true&expiry_schedule=true&expired_points=true"
      );

      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const customerDetailsSlice = createSlice({
  name: "customer",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchCustomerDetails.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchCustomerDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.customerDetailsData = action.payload?.customers?.customer[0];
      state.success = action.payload?.status?.success === "true" ? true : false;
      state.error = "";
      localStorage.setItem(
        "customerDetails",
        JSON.stringify(action.payload?.customers?.customer[0])
      );
    });
    builder.addCase(fetchCustomerDetails.rejected, (state, action) => {
      state.loading = false;
      state.customerDetailsData = [];
      state.error = action.error.message;
    });
  },
});

export default customerDetailsSlice.reducer;
export { fetchCustomerDetails };
